import { render, staticRenderFns } from "./editdoc_payment_trans.vue?vue&type=template&id=0a658efc&scoped=true&"
import script from "./editdoc_payment_trans.vue?vue&type=script&lang=js&"
export * from "./editdoc_payment_trans.vue?vue&type=script&lang=js&"
import style0 from "./editdoc_payment_trans.vue?vue&type=style&index=0&id=0a658efc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a658efc",
  null
  
)

export default component.exports